
<template>
   <div class="login" id="bloque1" >

      <div class="loginBox">
        <img class="loginBoxImg"src="/dist/logo-login.png" >
        <p class="labels" id="titulo" style="font-weight: 400; font-size: 20px; margin-bottom: 0px" >Sales registro</p> 
        <p class="labels" id="info">Si quiere ingresar al sistema necesitamos darlo de alta, por favor complete los siguientes datos y nos pondremos en contacto para darle acceso</p> 

        <form @submit.prevent>
          <div class="container1">
            <div class="container2">
              <p class="labels">NOMBRE</p>
              <input class="inputBoxS" :class="{inputBoxSInv: errorNombre}" type="text" v-model='nombre' >
            </div>  
            <div class="container2" style="margin-left: 20px">
                <p class="labels">APELLIDO</p>
                <input class="inputBoxS"  :class="{inputBoxSInv: errorApellido}" type="text" v-model='apellido' >
            </div>  
          </div>

          <p class="labels">NOMBRE DEL COMERCIO</p>
          <input class="inputBoxL"  :class="{inputBoxLInv: errorNombreComercio}" type="text" v-model='nombreComercio' >
          <p class="labels">DIRECCIÓN</p>
          <input class="inputBoxL" :class="{inputBoxLInv: errorDireccion}" type="text" v-model='direccion' >
  
          <div class="container1">
              <div class="container2">
                <p class="labels">EMAIL</p>
                <input class="inputBoxS" :class="{inputBoxSInv: errorEmail}"  type="email" v-model='email' >
              </div>  
              <div class="container2" style="margin-left: 20px">
                  <p class="labels">TELÉFONO</p>
                  <input class="inputBoxS" :class="{inputBoxSInv: errorTelefono}"  type="text" v-model='telefono' >
              </div>  
          </div>

          <div id="btnContainer">
            <button  id="btnCancelar" @click="btnCancelar" >CANCELAR</button>
            <button  id="btnEnviar"   @click="btnEnviar"   >ENVIAR</button>
          </div> 
        </form>

      </div>
  </div>
</template>

<script>


import axios from 'axios'

export default {

  name: 'Registro',

  data () {
    return {
      nombre:'',
      apellido:'',
      nombreComercio:'',
      direccion:'',
      email:'',
      telefono:'',
      errorNombre:false,
      errorApellido:false,
      errorNombreComercio:false,
      errorDireccion:false,
      errorEmail:false,
      errorTelefono:false,
    }
  },

  methods: 
  {
    
    btnEnviar () {
      this.validar()  
    },

    validar () {
      this.errorNombre=false
      this.errorApellido=false
      this.errorNombreComercio=false
      this.errorDireccion=false
      this.errorEmail=false
      this.errorTelefono=false

      if (this.nombre.length < 3)  
      {
        this.errorNombre =true
      }
      if (this.apellido.length < 2)
      {
        this.errorApellido =true
      }
      if (this.direccion.length < 6)
      {
        this.errorDireccion =true
      }
      if (this.telefono.length < 6)
      {
        this.errorTelefono =true
      }
      if (this.email.length < 6)
      {
        this.errorEmail =true
      }
      if (this.nombreComercio < 1)
      {
        this.errorNombreComercio =true
      }

      if (!this.errorNombre && !this.errorApellido && !this.errorDireccion && !this.errorTelefono && !this.errorEmail && !this.errorNombreComercio)
      {
        this.enviarSolicitud()
      }

   },


    enviarSolicitud () 
    {
       this.$store.commit('loader/start')
       var dataRegistro = { 'Nombre': this.nombre,
                            'Apellido': this.apellido, 
                            'Direccion': this.direccion, 
                            'Telefono': this.telefono, 
                            'Email': this.email, 
                            'Comercio': this.nombreComercio, 
                          }

       axios.post('/WebSalesCliente', dataRegistro ,{
         headers:{
                   ClientSecret: process.env.CLIENT_SECRET,
                   EmpresaId: process.env.EMPRESA_ID
                 }
         }
       )
        .then((response) => {
          this.$store.commit('loader/stop')
          if (response.data.Code == 0)
          {
            var obj = {
                       txt:'Su solicitud de acceso fue enviada exitosamente, en breve recibirá un email con su usuario y contraseña',
                       txtBtnCancel:'',
                       txtBtnOk:'Aceptar',
                       fCancel:null,
                       fOk:this.registroOk
                      }
            this.$store.commit('popup/open',obj);
          }
          else 
          {
            var obj = {
                       txt:response.data.Message,
                       txtBtnCancel:'',
                       txtBtnOk:'Aceptar',
                       fCancel:null,
                       fOk:null
                      }
            this.$store.commit('popup/open',obj);
          }
        })
        .catch((error) => {
          alert("error") 
          console.log(error);
        });

    },

    btnCancelar () 
    {
      this.$router.push({name: 'login'});
    },


    registroOk () 
    {
      this.$router.push({name: 'login'});
    },




  },

  mounted () {
    this.$store.commit('loader/stop')
  }

}
</script>




<style scoped>

*{
  margin:  0;
  padding: 0;
}


.container1{
  display: flex;            
  flex-direction:row;  
}

.container2{
  display: flex;            
  flex-direction:column;  
}


#bloque1{
  width:100%;
  height:100vh;
  background: linear-gradient(#005A9F , #1899D6);

}


.loginBox{
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);
width: 400px;
height: 480px;
padding: 20px;
border-radius: 15px;
box-sizing: border-box;
background: #ffffff;
}


.loginBoxImg{
width: 100px;
height: 100px;
border-radius: 50%; 
overflow: hidden;
position: absolute;
top: calc(-100px/2);
left:calc(50% - 50px);
}



.labels
{
  margin: 0;
  padding-bottom: 5px;
  font-weight: 500;
  font-size: 10px;
  color: #5c666f; 
} 



#titulo{
margin-top: 50px;
padding: 0,0,20px;  
font-weight: bold;
text-align: center;
font-size: 20px;
}

#info{
margin-top: 10px;
margin-bottom: 15px;
padding: 0,0,20px;  
font-weight: normal;
text-align: center;
font-size: 12px;
text-align: justify;
}


.inputBoxS
{
  width:164px;
  margin-bottom: 20px;
  padding-left: 5px;
  border-radius: 5px;  
  margin-bottom: 10px;
  height:30px;
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #dddddd;
}

.inputBoxL
{
  width:355px;
  margin-bottom: 20px;
  padding-left: 5px;
  border-radius: 5px;  
  margin-bottom: 10px;
  height:30px;
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #dddddd;
}


.inputBoxSInv
{
  width:164px;
  margin-bottom: 20px;
  padding-left: 5px;
  border-radius: 5px;  
  margin-bottom: 10px;
  height:30px;
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #ff0000;
}


.inputBoxLInv
{
  width:355px;
  margin-bottom: 20px;
  padding-left: 5px;
  border-radius: 5px;  
  margin-bottom: 10px;
  height:30px;
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #ff0000;
}





#btnContainer{
margin-top: 30px;  
text-align: center;
}

input[type="submit"]
{
  height: 30px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 20px;  
  border-style: solid;
  border:none; 
}


#btnCancelar{
  font-size: 10px;
  font-weight: bold;
  border-radius: 20px;  
  border-style: solid;
  margin-right: 5px;
  border:none; 
  width: 100px;
  height: 30px;
  color: #5c666f;
  background: #ffffff; 
  border-width: 1px;
  border: 2px solid #5c666f;
  margin-right: 5px;
  outline: none;
}

#btnEnviar{
  font-size: 10px;
  font-weight: bold;
  border-radius: 20px;  
  border-style: solid;
  margin-left: 5px;
  border:none; 
  width: 80px;
  height: 30px;
  background: #005A9F; 
  color: #ffffff;
  margin-left: 5px;
  outline: none;
}

#btnCancelar:hover { cursor: pointer; }
#btnEnviar:hover { cursor: pointer; }



</style>



// WEBPACK FOOTER //
// src/components/views/login/registro.vue